
import { BaseButton } from "./button.styles";
const Button = ({children, style})=>{
	return(
		<BaseButton style={style}>{children}</BaseButton>
	)
}

export default Button;